import styled from 'styled-components';
import { FullWidth } from 'ui/utility/fullWidth';
import { colors, spacing, H3 } from 'ui/theme';
import { layoutLRPadding } from 'ui/theme/spacing';

export const FullWidthBackground = styled(FullWidth)`
  background-color: ${colors.grey1};
  padding: ${spacing.double} ${layoutLRPadding} ${spacing.x6};
`;

export const PageTitle = styled(H3)`
  margin-bottom: ${spacing.plusQuarter};
  padding-left: ${spacing.threeQuarter};
`;
